<template>
  <section
    class="app-main"
    :class="{ 'mr-top': !seeNavbarSidebar }"
  >
    <keep-alive>
      <router-view :key="key" />
    </keep-alive>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.fullPath;
    },
    seeNavbarSidebar(){
      let pathName=['LocationSlug','ReservationsSlug']
      return pathName.includes(this.$route.name)     
    },
  },
};
</script>
<style  lang="scss" scoped>
.mr-top {
  margin-top: 95px;
}
</style>


// WEBPACK FOOTER //
// AppMain.vue?57124376